export const billSwitchStrings = {
  productIntroScreen: {
    control: {
      title: 'Bill switch made simple',
      subtitle:
        'Whether its your phone, streaming, internet, and more, moving your bills to Varo is fast, secure, and stress-free.',
    },
    believe: {
      title: 'PAY BILLS WITH BELIEVE TO STAY ON TRACK',
      subtitle:
        'Bill Switch makes it easy to move everyday bills to your Believe Card in minutes.',
    },
    featureBullets: {
      one: 'Detects your current bills automatically',
      two: 'Choose multiple bills to switch at once',
      three: 'Securely update your payment details in one flow',
    },
    believeFeatureBullets: {
      one: 'On-time Believe payments can help support your credit',
      two: 'Bill Switch auto-detects eligible bills',
      three: 'Move multiple bills to Believe at once',
    },
    productInfoFooter:
      'Bill Switch provides you with 1-click bill switching for 100+ most common merchants and guided switching for 1,000+ more.',
    unlockCardsText:
      'Make sure your Varo cards are not frozen to successfully switch bills.',
    cta: {
      primary: 'Move my bills',
    },
  },
  unfreezeCardsBottomSheet: {
    title: 'Unfreeze your card to switch bills',
    body: 'Make sure your card is unfrozen before switching any bills.',
    cardItem: {
      title: {
        debit: 'Varo Debit Card',
        believe: 'Varo Believe Card',
      },
      state: {
        frozen: 'Card frozen',
        unfrozen: 'Card unfrozen',
      },
    },
    buttons: {
      primary: 'Move my bills',
      secondary: 'Not now',
    },
    error: {
      noActiveCards: {
        title: 'Make sure your Varo cards are active',
        message:
          'You need an active Varo Debit Card or Varo Believe Card to switch your bills.',
      },
      noActiveCardsBelieve: {
        title: 'Your Varo Believe Card isn’t active',
        message: 'You need an active Believe card to switch your bills.',
      },
    },
  },
  fundingScreen: {
    title: 'Add money',
    subtitle:
      'Make sure you have funds to cover your upcoming recurring payments. ',
    alert: {
      title: 'Estimated amount for your new bills',
    },
    fundingOptions: {
      p2p: {
        title: 'Cash App, PayPal or Venmo',
        tag: 'Instant',
      },
      transfer: {
        title: 'Bank transfer',
        tag: 'Up to 2 days',
      },
      cashDeposit: {
        title: 'Cash deposit',
        tag: 'Instant',
      },
      dcf: {
        title: 'Fund instantly from debit card',
        tag: 'Instant',
      },
    },
    cta: {
      secondary: 'Not now',
    },
  },
  fundingScreenBelieve: {
    title: 'Add money to your account',
    body: 'Make sure you have funds to cover your upcoming recurring payments.',
    alert: {
      title: 'Estimated amount for your new bills',
    },
    nav: {
      skip: 'Skip',
    },
    cta: {
      primary: 'Next',
    },
  },
  featureErrors: {
    featureUnavailable: {
      title: 'Feature unavailable',
      message: "We're working on it.",
    },
    unableToLaunchPinwheel: {
      message: `This page isn't loading right now. We're working on it.`,
    },
  },
};

export default billSwitchStrings;
